import { IComparable } from "../Utils/ObjUtils";


export class SnmpOid {

	private values: number[];

	public static Create(oidStr: string): SnmpOid {

		if (oidStr) {
			let validateRE = /^\d+(\.\d+)*$/;

			if (validateRE.test(oidStr)) {
				let parseRE = /\.?(\d+)/g;
				let values: number[] = [];

				let found;
				while ((found = parseRE.exec(oidStr)) !== null) {
					values.push(parseInt(found[1]));
				}

				return new SnmpOid(values);
			}
		}

		return null;
	}

	constructor(values: number[]) {
		if (values.length == 0) {
			throw new Error("Invalid values in SnmpOid");
		}

		this.values = [...values];
	}

	public toString(): string {
		let result = "" + this.values[0];

		for (let i = 1; i < this.values.length; ++i) {
			result += "." + this.values[i];
		}

		return result;
	}

	public ToString(): string {
		return this.toString();
	}

	public CompareTo(other: SnmpOid): number {
		let myLen = this.values.length;
		let hisLen = other.values.length;
		let minLen = Math.min(myLen, hisLen);

		for (let i = 0; i < minLen; ++i) {
			let myVal = this.values[i];
			let hisVal = other.values[i];

			if (myVal < hisVal) {
				return -1;
			}
			else if (myVal > hisVal) {
				return 1;
			}
		}

		if (myLen < hisLen) {
			return -1;
		}
		else if (myLen > hisLen) {
			return 1;
		}
		else {
			return 0;
		}
	}

}
